import type { ContactStatus } from "features/contacts/blocks/PersonContact/PersonContact.types";
import type { ContactsListResponse } from "features/contacts/data/types";

export const getStatusKey = (
  status: ContactStatus,
): keyof ContactsListResponse | null => {
  if (status === "mutual") return "mutual_contacts";
  if (status === "my_request") return "my_requests";
  if (status === "their_request") return "their_requests";

  return null;
};

export const removeFromAllBuckets = (
  data: ContactsListResponse,
  personId: number,
): ContactsListResponse => ({
  mutual_contacts: data.mutual_contacts.filter((p) => p.id !== personId),
  my_requests: data.my_requests.filter((p) => p.id !== personId),
  their_requests: data.their_requests.filter((p) => p.id !== personId),
});
